"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headingDefaults = void 0;
var headingDefaults = {
  '.abyss-h1-desktop': {
    color: '$primary1',
    fontFamily: '$heading',
    fontWeight: '$semibold',
    fontSize: '2.281rem',
    lineHeight: '3rem'
  },
  '.abyss-h2-desktop': {
    color: '$primary1',
    fontFamily: '$heading',
    fontWeight: '$semibold',
    fontSize: '2.027rem',
    lineHeight: '3rem'
  },
  '.abyss-h3-desktop': {
    color: '$primary1',
    fontFamily: '$heading',
    fontWeight: '$semibold',
    fontSize: '1.802rem',
    lineHeight: '2.25rem'
  },
  '.abyss-h4-desktop': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '1.602rem',
    lineHeight: '2rem'
  },
  '.abyss-h5-desktop': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '1.424rem',
    lineHeight: '2rem'
  },
  '.abyss-h6-desktop': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '1.266rem',
    lineHeight: '1.5rem'
  },
  '.abyss-h1-desktop[data-display="1"]': {
    fontSize: '3.246rem',
    lineHeight: '4rem',
    fontWeight: '$semibold'
  },
  '.abyss-h1-desktop[data-display="2"]': {
    fontSize: '2.886rem',
    lineHeight: '3.5rem',
    fontWeight: '$semibold'
  },
  '.abyss-h1-desktop[data-display="3"]': {
    fontSize: '2.565rem',
    lineHeight: '3.25rem',
    fontWeight: '$semibold'
  },
  '.abyss-h1-mobile': {
    color: '$primary1',
    fontFamily: '$heading',
    fontWeight: '$semibold',
    fontSize: '2.027rem',
    lineHeight: '2.5rem'
  },
  '.abyss-h2-mobile': {
    color: '$primary1',
    fontFamily: '$heading',
    fontWeight: '$semibold',
    fontSize: '1.802rem',
    lineHeight: '2.25rem'
  },
  '.abyss-h3-mobile': {
    color: '$primary1',
    fontFamily: '$heading',
    fontWeight: '$semibold',
    fontSize: '1.602rem',
    lineHeight: '2rem'
  },
  '.abyss-h4-mobile': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '1.424rem',
    lineHeight: '1.75rem'
  },
  '.abyss-h5-mobile': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '1.266rem',
    lineHeight: '1.5rem'
  },
  '.abyss-h6-mobile': {
    color: '$primary1',
    fontFamily: '$primary',
    fontWeight: '$bold',
    fontSize: '1.125rem',
    lineHeight: '1.5rem'
  },
  '.abyss-h1-mobile[data-display="1"]': {
    fontSize: '2.866rem',
    lineHeight: '3.5rem',
    fontWeight: '$semibold'
  },
  '.abyss-h1-mobile[data-display="2"]': {
    fontSize: '2.565rem',
    lineHeight: '3.25rem',
    fontWeight: '$semibold'
  },
  '.abyss-h1-mobile[data-display="3"]': {
    fontSize: '2.281rem',
    lineHeight: '3rem',
    fontWeight: '$semibold'
  }
};
exports.headingDefaults = headingDefaults;